import React, {Component} from "react"

var textColorForTd={
  color: 'red',
}

class ColoredTD2 extends Component{
  render(){
    var value = this.props.value.toString()
    //console.log("Movement percentage :: "+value);
    if(value.startsWith("-")){
      var textColorForTd={
        color: 'green',
      }
      value = value.substring(1, value.length)+"%"

      return(
        <td style={textColorForTd}>{value}</td>
      )
    }else if(this.props.value=='n/a' || this.props.value=='0'){
      var textColorForTd={
        color: 'black',
      }
      return(
        <td style={textColorForTd}>{value+"%"}</td>
      )
    }
    else{
      var textColorForTd={
        color: 'red',
      }
      return(
        <td style={textColorForTd}>{value+"%"}</td>
      )
    }

  }
}
export default ColoredTD2
